import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { buttonVariants } from 'components/ui/button';
import CircularProgress from 'components/CircularProgress';
import { PATH_ROUTES } from 'routes/path';

export default function SingleScan({ score }: { score: number | undefined }) {
  const { t } = useTranslation();

  return (
    <div className='col-span-5 px-6 py-4 space-y-4 text-white rounded-2xl bg-primary-dark'>
      <div>
        <h2 className='text-lg font-semibold'>
          {t('single_scorecard_tile_header')}
        </h2>
        <p className='leading-none text-green-600'>
          {t('single_scorecard_tile_subheader')}
        </p>
      </div>

      <div className='grid items-center grid-cols-2 gap-4'>
        <p className='text-sm leading-tight'>
          {t('single_scorecard_tile_msg')}
        </p>

        <div className='relative'>
          <div className='absolute -top-10 right-8 size-24'>
            <CircularProgress score={score || 0} />
          </div>
        </div>
      </div>

      <Link
        to={PATH_ROUTES.FACE_SCAN}
        className={buttonVariants({
          className:
            'h-8 text-sm font-medium !text-gray-800 bg-white hover:bg-white',
        })}
      >
        {t('see_detailed_report')}
      </Link>
    </div>
  );
}
